import { Alert, AlertProps } from '@mui/material';
import { t } from 'i18next';

export default function EmptyMessage () {
  return (
    <Alert
      color={'primary' as AlertProps['color']}
      severity='info'
      style={{
        margin: '16px',
        background: '#FFF'
      }} >
      <>
        {t('emptyListMessage')}
      </>
    </Alert>
  );
}
